import { BaseComponent } from './BaseComponent';
import { ComponentRef } from '@wix/editor-platform-sdk-types';
import {
  ComponentsNamespaceErrorCode,
  createComponentsNamespaceError,
} from '../errors';

export class UnknownComponent extends BaseComponent<never> {
  public type = null;

  constructor(public compRef: ComponentRef, _unknownCompType: string) {
    super();
  }

  getProp(_prop: never) {
    throw createComponentsNamespaceError(
      ComponentsNamespaceErrorCode.UnknownComponentGetProp,
      'only text and image components are supported',
    );
  }

  setProp() {
    throw createComponentsNamespaceError(
      ComponentsNamespaceErrorCode.UnknownComponentSetProp,
      'only text and image components are supported',
    );
  }
}
